export interface ComparisonRow {
  dimension: string;
  traditional: string;
  uniqreach: string;
}

export function Comparison({ rows }: { rows: ComparisonRow[] }) {
  return (
    <div
      className="comparison"
      role="table"
      aria-label="Manual outbound compared with the UniqReach approach"
    >
      <div className="comparison-head" role="row">
        <span role="columnheader">The difference</span>
        <span role="columnheader">Manual outbound</span>
        <span role="columnheader">With UniqReach</span>
      </div>
      {rows.map((row) => (
        <div className="comparison-row" role="row" key={row.dimension}>
          <div className="comparison-dimension" role="rowheader">
            {row.dimension}
          </div>
          <div className="comparison-manual" role="cell">
            <span className="comparison-mobile-label" aria-hidden="true">
              Manual outbound
            </span>
            {row.traditional}
          </div>
          <div className="comparison-system" role="cell">
            <span className="comparison-mobile-label" aria-hidden="true">
              With UniqReach
            </span>
            {row.uniqreach}
          </div>
        </div>
      ))}
    </div>
  );
}
